import ParticleBackground from './ParticleBackground';

export default function HeroSection() {
  return (
    <section
      id="hero"
      className="relative w-full h-screen min-h-[700px] flex items-center justify-center overflow-hidden"
    >
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Ethereal%20floating%20translucent%20light%20curtains%20drifting%20in%20cosmic%20void%2C%20soft%20champagne%20and%20warm%20ivory%20tones%20with%20scattered%20stardust%20particles%2C%20feminine%20clean%20aesthetic%2C%20minimal%20abstract%20futuristic%20composition%2C%20dreamy%20nebula%20glow%20with%20gentle%20light%20rays%2C%20high%20key%20lighting%2C%20editorial%20fine%20art%20photography%20style%2C%20serene%20atmosphere%20with%20flowing%20luminous%20fabric&width=1800&height=1200&seq=rse-hero-bg-01&orientation=landscape"
          alt="合同会社RSE - 未来を紡ぐテクノロジー"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/20 to-black/35"></div>
      </div>

      <ParticleBackground />

      <div className="relative z-10 w-full max-w-6xl mx-auto px-6 md:px-10 flex flex-col items-start">
        <div className="max-w-2xl">
          <p className="text-white/70 text-sm md:text-base tracking-[0.3em] font-light mb-6 animate-fadeIn">
            TOKYO . SHINJUKU
          </p>
          <h1 className="font-heading text-4xl sm:text-5xl md:text-7xl lg:text-8xl font-light text-white leading-[1.15] tracking-wide mb-8 animate-fadeIn animation-delay-200">
            未来を紡ぐ<br />
            テクノロジーと<br />
            <span className="font-medium">クリーンな光</span>
          </h1>
          <p className="text-white/75 text-base md:text-lg leading-relaxed max-w-lg mb-10 animate-fadeIn animation-delay-400">
            ソフトウェア開発からITコンサルティングまで。
            合同会社RSEは、東京・新宿を拠点に
            最先端の技術と洗練された感性で、
            あなたのビジネスに光を灯します。
          </p>
          <div className="flex flex-col sm:flex-row gap-4 animate-fadeIn animation-delay-600">
            <a
              href="#services"
              className="px-8 py-3.5 rounded-full bg-white/15 backdrop-blur-sm text-white border border-white/30 text-sm font-medium hover:bg-white/25 transition-all duration-300 text-center whitespace-nowrap cursor-pointer"
            >
              事業内容を見る
              <i className="ri-arrow-down-line ml-2"></i>
            </a>
            <a
              href="#contact"
              className="px-8 py-3.5 rounded-full bg-white text-foreground-900 text-sm font-medium hover:bg-white/90 transition-all duration-300 text-center whitespace-nowrap cursor-pointer"
            >
              お問い合わせ
              <i className="ri-arrow-right-line ml-2"></i>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}